import { css } from 'styled-components';

const styles = css`
  .resend-code-text {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    text-align: center;
    .resent-code-cta {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      padding-left: 4px;
      color: ${(props) => props.theme.colorPalette.gray[900]};
    }
    button {
      background: none;
      border: none;
      cursor: pointer;
      text-decoration: underline;
      color: ${(props) => props.theme.colorPalette.blue.C900};
      outline: none;
    }
  }
  .recaptcha_loginotp {
    ${(props) =>
      props.isLoginWithOTPEnabled &&
      `display: flex;
    flex-direction: column;
    align-items: center;`}
    .TextBox__error {
      ${(props) =>
        props.isLoginWithOTPEnabled &&
        `margin-top: 5px;
    margin-right: 100px;`}
    }
  }

  .otp-wrapper {
    margin: ${(props) => props.isLoginWithOTPEnabled && '0px 70px 0px 70px'};
  }

  .login-error {
    margin: ${(props) => props.isLoginWithOTPEnabled && '8px 0px 0px 5px;'};
  }
  @media (max-width: 850px) {
    .otp-wrapper {
      margin: ${(props) => props.isLoginWithOTPEnabled && '0px 50px 0px 50px;'};
    }
  }
  @media (max-width: 430px) {
    .otp-wrapper {
      margin: ${(props) =>
        props.variation === 'checkout' ? '0px 20px 0px 20px' : '0px 45px 0px 45px;'};
    }
  }
  .resent-code-link {
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }
`;

export default styles;
